import { render, staticRenderFns } from "./CriteriaManagement.vue?vue&type=template&id=3f8b1156&scoped=true"
import script from "./CriteriaManagement.vue?vue&type=script&lang=js"
export * from "./CriteriaManagement.vue?vue&type=script&lang=js"
import style0 from "./CriteriaManagement.vue?vue&type=style&index=0&id=3f8b1156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b1156",
  null
  
)

export default component.exports